<template>
	<div v-loading="loading" style="width: 100%;height: 100%;min-height: 500px;">
		<div v-if="data && data.shareUrl" style="display: flex;align-items: center;font-size: 14px;margin-top: 20px;">
			<div style="padding: 4px 6px;background-color: #f0f9eb ;color: #67c23a;">
				{{$t('h.shareLink')}} : {{data.shareUrl}}
			</div>
			<div>
				<el-button size="mini" type="success" style="margin-left: 60px;" plain
					@click="copy(data.shareUrl)">{{$t('h.copy')}}</el-button>
			</div>
		</div>
		<div v-if="data"
			style="display: flex;align-items: center;margin-top: 30px;font-size: 14px;font-weight: bold;color: #616161;">
			<div>{{$t('h.superior')}}:</div>
			<div style="margin-left: 6px;">
				{{data.myParentCustomer?data.myParentCustomer.email :$t('h.wu')}}
			</div>
		</div>
		<!-- 	<div style="display: flex;align-items: center;" v-if="data && data.myParentCustomer">
			<div>我的直属上级</div>
			<div style="margin-left: 10px;">
				{{data.myParentCustomer.email}}
			</div>
		</div> -->
		<div v-if="data" style="margin-top: 30px;font-size: 14px;font-weight: bold;color: #616161;">
			{{$t('h.subordinate')}}
		</div>
		<div style="overflow-x: scroll;" :style="{
			width: equipment == 'pc'?'none':'88vw'
		}">
			<el-table v-if="data" :data="data.users.data" style="width: 100%;margin-top: 10px;">
				<el-table-column prop="date_at" :label="$t('h.addTime')" width="180">
				</el-table-column>
				<el-table-column prop="customer.name" :label="$t('h.name')" width="180">
				</el-table-column>
				<el-table-column prop="account" :label="$t('h.userAccount')">
				</el-table-column>
				<el-table-column prop="code" :label="$t('h.recommendationCode')">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import {
		getCommissionShopUsers
	} from '../../../../api/all.js'
	export default {
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			userInfo: {
				type: Object,
				default: () => {
					return {}
				}
			},
		
		},
		data() {
			return {
				loading: false,
				data: null,
				search: {
					page: 1,
					end_time: '',
					start_time: '',
					pageSize: 10,
					q: '',
				}
			}
		},
		async mounted() {
			await this.getData()
		},
		methods: {
			copy(e) {
				/* 获取文本内容 */
				// var copyText = document.getElementById("myInput");

				// /* 选择复制内容 */
				// copyText.select();
				// copyText.setSelectionRange(0, 99999); /* 为移动设备设置 */

				/* 复制内容到文本域 */
				navigator.clipboard.writeText(e);
				this.$message.success(this.$t('h.copySuccess'))

			},
			async getData() {
				this.loading = true
				try {
					const data = await getCommissionShopUsers(this.search)
					console.log('getDatadata', data)
					this.data = data.data
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			}
		}
	}
</script>

<style>
</style>